<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-product-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <form v-on:submit.prevent="submitCreateOrUpdateOrder">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25" v-if="customer">
              <label class="d-block text-black fw-semibold mb-10">
                Shipping Address
              </label>
              <select class="form-select shadow-none fw-semibold rounded-0"
                name="shippingAddress"
                v-model="shippingAddressId"
              >
                <option v-for="address in addresses" :value="address.id" :key="address.id">{{ address.name }}, {{ address.address_line_1 }}{{ address.address_line_2 ? ', '+address.address_line_2 : '' }}, {{ address.postal_code }} {{ address.city }}, {{ address.state_or_region }}, {{ address.country_code }} </option>
              </select>
              <div class="invalid-feedback" id='shippingAddressError'></div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25" v-if="customer">
              <label class="d-block text-black fw-semibold mb-10">
                Marketplace
              </label>
              <select class="form-select shadow-none fw-semibold rounded-0"
                name="marketplace"
                v-model="marketplaceId"
                :disabled="orderItems.length"
              >
                <option v-for="marketplace in marketplaces" :value="marketplace.id" :key="marketplace.id">{{ marketplace.name }}</option>
              </select>
              <div class="invalid-feedback" id='productTypeError'></div>
            </div>
          </div>
          <div class="col-md-12 mb-25">
            <div class="d-flex mb-15 justify-content-between">
              <h5 class="card-title fw-bold">
                Order Items
              </h5>
              <button type="button" class="btn btn-outline-primary btn-sm position-relative" data-bs-toggle="modal" data-bs-target="#addOrderItemModal" v-on:click="addOrderItemClicked()">Add Order Item</button>
            </div>
            <ul class="list-group">
              <li class="list-group-item list-group-item-warning fw-medium fs-md-15" v-if="orderItems.length == 0">Please add items to the order.</li>
              <li class="list-group-item fw-medium fs-md-15 d-flex justify-content-between" v-for="orderItem in orderItems" :key="orderItem.id">
                <div class="d-flex flex-column">
                  <p class="mb-1 fs-md-15 fs-lg-16">{{ orderItem.quantity }} x {{ orderItem.name }}</p>
                  <small>SKU: {{ orderItem.sku }}</small>
                </div>
                <div class="dropdown">
                  <button
                    class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition fs-20 no-after text-paragraph"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        data-bs-toggle="modal" data-bs-target="#addOrderItemModal"
                        class="dropdown-item d-flex align-items-center"
                        v-on:click="editOrderItem(orderItem.sku)"
                        ><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Edit
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center cursor-pointer"
                        v-on:click="deleteOrderItem(orderItem.sku)"
                        ><i
                          class="flaticon-delete lh-1 me-8 position-relative top-1"
                        ></i>
                        Delete</a
                      >
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-md-12">
            <button
              class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
              type="submit"
            >
              {{ order ? 'Update' : 'Create' }} Order
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="addOrderItemModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ updateItemProductUid ? 'Edit' : 'Add' }} Order Item</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-2">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10"
                  >Quantity</label
                >
                <input
                  type="number"
                  step="1"
                  class="form-control shadow-none rounded-0 text-black"
                  v-model="newOrderItemQty"
                />
              </div>
            </div>
            <div class="col-md-10">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10"
                  >Product</label
                >
                <model-select
                  class="form-control shadow-none rounded-0 text-black"
                  placeholder="e.g. Black Wristband"
                  name="newOrderItemProductUid"
                  v-model="newOrderItemProductUid"
                  :options="newOrderItemOptions"
                  @searchchange="updateProductSearch"
                >
              </model-select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" v-on:click="addOrUpdateOrderItem" class="btn btn-outline-primary">{{ updateItemProductUid ? 'Update' : 'Add'}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import "vue-search-select/dist/VueSearchSelect.css"
import { defineComponent } from "vue";
import { ModelSelect } from "vue-search-select";
import showToast from '../../utils/showToast';
import apiConnector from '../../utils/apiConnector';
import router from "../../router";
import { Modal } from "bootstrap";
import $ from "jquery";

export default defineComponent({
  name: "AddOrEditMerchantOrder",
  emits: ["pageUpdate"],
  components: {
    ModelSelect
  },
  mounted(){
    this.getCustomer();
    if(this.$route.name == "EditMerchantOrderPage"){
      // this.getEditOrder();
    }
  },
  data() {
    return {
      customer: null as any,
      addresses: [] as Array<any>,
      shippingAddressId: null as any,
      order: null as any,
      marketplaceId: null as any,
      orderItems: [] as Array<any>,
      newOrderItemQty: 10,
      newOrderItemProductUid: null,
      returnedProducts: [] as Array<any>,
      newOrderItemOptions: [] as Array<any>,
      newOrderItemProductSearch: '',
      updateItemProductUid: null,
      marketplaces: [
        {
          id: null,
          name: 'All'
        },
        {
          id: 3,
          name: 'Amazon'
        },
        {
          id: 6,
          name: 'Walmart'
        }
      ]
    }
  },
  methods: {
    async searchProducts(search='') {
      const marketplaceParam = this.marketplace.id ? `&marketplace=${this.marketplace.name}` : '';
      const response = await apiConnector.makeGetRequest(`/products?search=${search}${marketplaceParam}`);
      this.returnedProducts = response.data.data;
      this.newOrderItemOptions = this.returnedProducts.map(product => { return {
        text: product.name + ' / ' + product.sku + (product.upc ? ' / ' + product.upc : ''),
        value: product.uid
      }});
    },
    async getCustomer() {
      if(!this.$route.params.customer_id){
        return false;
      }
      const response = await apiConnector.makeGetRequest('/merchant-customers/'+this.$route.params.customer_id);
      this.customer = response.data.data;
      this.shippingAddressId = this.customer.primary_shipping_address.data.id;
      this.addresses = this.customer.addresses.data;
    },
    // async getEditOrder() {
    //   if(!this.$route.params.id){
    //     return false;
    //   }
    //   const response = await apiConnector.makeGetRequest('/merchant-orders/'+this.$route.params.id);
    //   this.order = response.data.data;
    //   this.orderItems = this.order.orderItems.data;
    // },
    async submitCreateOrUpdateOrder() {
      if(!this.validates()){
        return false;
      }
      const payload = this.buildOrderPayload();
      let response = null as any;
      if(this.$route.name == "EditMerchantOrderPage"){
        if(!this.order){
          return false;
        }
        response = await apiConnector.makePatchRequest(`/merchant-orders/${this.order.id}`, payload);
      }else{
        response = await apiConnector.makePostRequest('/merchant-orders', payload);
      }
      if(response && response.data && response.data.data){
        let action = this.$route.name == "EditMerchantOrderPage" ? 'Updated' : 'Created';
        router.push({path: '/wholesale/orders'});
        showToast(`Merchant Order Successfully ${action}`);
        if(this.$route.name != "EditMerchantOrderPage"){
          this.order = response.data.data;
          this.$emit('pageUpdate', 'EditMerchantOrderPage');
        }
      }
    },
    buildOrderPayload(){
      let payload = {
        customer: this.customer,
        shipping: this.shippingAddress,
        items: this.orderItems,
        wholesale: 1,
        total: 0
      };
      if(this.marketplaceId){
        payload['marketplace'] = this.marketplace.name;
      }
      return payload;
    },
    validates(){
      let shippingAddressValidation = this.validateShippingAddress();
      let orderItemsValidation = this.validateOrderItems();
      return shippingAddressValidation && orderItemsValidation;
    },
    validateShippingAddress(){
      if(!this.shippingAddressId){
        $('select[name=shippingAddress]').addClass('is-invalid');
        let message = 'Shipping address is required';
        $('#shippingAddressError').html(message);
        return false
      }
      $('select[name=shippingAddress]').removeClass('is-invalid');
      $('#shippingAddressError').html('');
      return true;
    },
    validateOrderItems(){
      const missingItemsMsg = $('.list-group-item-warning');
      if(this.orderItems.length == 0){
        missingItemsMsg.addClass('list-group-item-danger').removeClass('list-group-item-warning');
        missingItemsMsg.append(' (Order items are required)');
        return false
      }
      missingItemsMsg.addClass('list-group-item-warning').removeClass('list-group-item-danger');
      return true;
    },
    addOrderItemClicked(){
      this.newOrderItemQty = 10;
      this.newOrderItemProductSearch = '';
      this.newOrderItemProductUid = null;
      this.returnedProducts = [];
      if(this.marketplaceId){
        this.updateProductSearch();
      }
      this.newOrderItemOptions = [];
      this.updateItemProductUid = null;
    },
    addOrUpdateOrderItem(){
      let selectedProduct = this.newItemSelectedProduct;
      selectedProduct['quantity'] = this.newOrderItemQty;
      selectedProduct['total'] = 0;
      if(!this.updateItemProductUid){
        this.orderItems.push(selectedProduct);
      }else{
        for(let i=0; i < this.orderItems.length; i++){
          if(this.orderItems[i].uid == this.updateItemProductUid){
            this.orderItems[i] = selectedProduct;
            break;
          }
        }
      }
      let addOrderItemModal = Modal.getInstance($('#addOrderItemModal'));
      if(addOrderItemModal){
        addOrderItemModal.hide();
      }
      this.newOrderItemQty = 1;
      this.newOrderItemProductSearch = '';
      this.newOrderItemProductUid = null;
      this.returnedProducts = [];
      this.newOrderItemOptions = [];
      this.updateItemProductUid = null;
    },
    deleteOrderItem(sku){
      for(let i=0; i < this.orderItems.length; i++){
        if(this.orderItems[i].sku == sku){
          this.orderItems.splice(i, 1);
          break;
        }
      }
    },
    editOrderItem(sku){
      for(let i=0; i < this.orderItems.length; i++){
        if(this.orderItems[i].sku == sku){
          let editOrderItem = this.orderItems[i];
          this.newOrderItemQty = editOrderItem.quantity;
          this.newOrderItemProductUid = editOrderItem.uid;
          this.returnedProducts = [];
          this.newOrderItemOptions = [];
          this.updateProductSearch(editOrderItem.sku);
          this.updateItemProductUid = editOrderItem.uid;
          break;
        }
      }
    },
    updateProductSearch(productSearch=''){
      if(productSearch || (this.marketplaceId && !this.newOrderItemProductUid)){
        this.newOrderItemProductSearch = productSearch;
        this.searchProducts(productSearch);
      }
    }
  },
  computed: {
    shippingAddress(): any {
      return this.addresses.find(address => address.id == this.shippingAddressId);
    },
    marketplace(): any {
      return this.marketplaces.find(marketplace => marketplace.id == this.marketplaceId);
    },
    newItemSelectedProduct(): any {
      return this.returnedProducts.find(product => product.uid == this.newOrderItemProductUid);
    },
  },
});
</script>